var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"p-1 full-screen container"},[_c('iframe',{staticClass:"full-screen",attrs:{"src":_vm.file_source,"width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }